import React from 'react';
import { signupGreeting } from '../utils/signupUxCopy';

export const SIGNUP_GREETING_CSS = `
  .signup-greeting {
    margin: 0 0 .45rem;
    font-size: .8rem;
    font-weight: 600;
    line-height: 1.3;
    color: var(--primary, #D32F2F);
  }
`;

export function readSignupFullName() {
  try {
    return (
      sessionStorage.getItem('fullName') ||
      localStorage.getItem('fullName') ||
      sessionStorage.getItem('patientName') ||
      localStorage.getItem('patientName') ||
      ''
    );
  } catch {
    return '';
  }
}

const SignupGreeting = ({ fullName }) => {
  const text = signupGreeting(fullName);
  if (!text) return null;
  return <p className="signup-greeting">{text}</p>;
};

export default SignupGreeting;
